import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import { mediaQuery } from '../../utils/styles';

export const StyledTnCLinksWithModal = styled.div`
  .link-wrapper {
    gap: 8px;
    font-size: ${toRem(12)};
    flex-wrap: wrap;
    .link-divider {
      border-left: ${toRem(1)} solid ${baseVariables.color.base10};
    }
    a {
      font-weight: 500;
      border-bottom: 1px solid ${baseVariables.color.base10};
      font-size: ${toRem(14)};
      line-height: ${toRem(16)};
      @media ${mediaQuery.mobileTablet} {
        font-size: ${toRem(16)};
      }
      @media ${mediaQuery.tabletMax} {
        font-size: ${toRem(16)};
      }
    }
  }
`;
